import { useEffect, useContext } from 'react';
import { getCampaignList, getDomainRatingDistribution, getLinkAcquisitionsByMonth, getLinksByMonth } from '../services/index.service';
import { storeContext } from '../../provider/Provider';
import { digitalPRActions } from '../../../store/digital-pr-reducer';

const useLoadDigitalPR = () => {
   const { state, dispatch } = useContext(storeContext);
   // const COMPLETE = 'complete';
   const monthDescending = '-month';

   useEffect(() => {
      dispatch({
         type: digitalPRActions.RESET_DATA,
      });
   }, [state.websiteSwitch.currentWebsite]);

   useEffect(() => {
      const fetchCampaignList = async () => {
         dispatch({
            type: digitalPRActions.SET_LOADING,
            payload: { 
                  campaignsLoading: true,
               },
         });
         try {
             const res = await getCampaignList({
               with_groups: true,
               page: state.digitalPR.campaignFilters.page + 1,
               page_size: state.digitalPR.campaignFilters.perPage,
               ordering: monthDescending,
               client_domain: state.websiteSwitch.currentWebsite,
               reviewed: 1,
               date_range_after: state.digitalPR.campaignFilters.fromDate,
               date_range_before: state.digitalPR.campaignFilters.toDate,
               search: state.digitalPR.campaignFilters.searchTerm,
               ...state.digitalPR.activeOrderBy? {ordering: state.digitalPR.activeOrderBy}: {}
             });
             if (!res.data) {
                 return;
             }
             
            dispatch({
               type: digitalPRActions.SET_CAMPAIGNS,
               payload: { 
                  campaignList: res.data?.results,
               }
            });
            dispatch({
               type: digitalPRActions.SET_TOTAL_CAMPAIGNS,
               payload: { 
                  totalCampaigns: res.data?.count
               }
            });
         } finally {
            dispatch({
               type: digitalPRActions.SET_LOADING,
               payload: { 
                  campaignsLoading: false,
               }
            });
         }
     }
     fetchCampaignList();
   }, [
      state.digitalPR.campaignFilters.page,
      state.digitalPR.campaignFilters.perPage,
      state.digitalPR.campaignFilters.fromDate, 
      state.digitalPR.campaignFilters.toDate, 
      state.digitalPR.campaignFilters.searchTerm,
      state.digitalPR.activeOrderBy,
      state.websiteSwitch.currentWebsite
   ])

   useEffect(() => {
      const fetchLinksByMonth = async () => {
         dispatch({
            type: digitalPRActions.SET_LINKS_BY_MONTH_LOADING,
            payload: { 
               linksByMonthLoading: true,
            },
          });
         try {
             const res = await getLinksByMonth({
               client_domain: state.websiteSwitch.currentWebsite,
               reviewed: 1,
             });
             if (!res.data) {
                 return;
             }
             
             dispatch({
               type: digitalPRActions.SET_LINKS_BY_MONTH,
               payload: { 
                  linksByMonth: res.data,
               },
             });
         } finally {
            dispatch({
               type: digitalPRActions.SET_LINKS_BY_MONTH_LOADING,
               payload: { 
                  linksByMonthLoading: false,
               },
             });
         }
     }
     const fetchLinkAcquisitionsByMonth = async () => {
      dispatch({
         type: digitalPRActions.SET_LINKS_BY_LINK_MONTH_LOADING,
         payload: { 
            linksByMonthLoading: true,
         },
       });
      try {
          const res = await getLinkAcquisitionsByMonth({
            client_domain: state.websiteSwitch.currentWebsite,
            reviewed: 1,
          });

          if (!res.data) {
              return;
          }
          
          dispatch({
            type: digitalPRActions.SET_LINK_ACQUISITIONS_BY_MONTH,
            payload: { 
               linkAcquisitionsByMonth: res.data,
            },
          });
      } finally {
         dispatch({
            type: digitalPRActions.SET_LINK_ACQUISITIONS_BY_MONTH_LOADING,
            payload: { 
               linkAcquisitionsByMonthLoading: false,
            },
          });
      }
     }
     fetchLinksByMonth();
     fetchLinkAcquisitionsByMonth();
   }, [state.websiteSwitch.currentWebsite])

   useEffect(() => {
      const fetchDomainRatingDistribution = async () => {
         dispatch({
            type: digitalPRActions.SET_DOMAIN_RATING_DISTRIBUTION_LOADING,
            payload: { 
               domainRatingDistributionLoading: true,
            },
          });
         try {
             const res = await getDomainRatingDistribution({
               client_domain: state.websiteSwitch.currentWebsite,
               reviewed: 1,
             });
             if (!res.data) {
                 return;
             }
             
             dispatch({
               type: digitalPRActions.SET_DOMAIN_RATING_DISTRIBUTION,
               payload: { 
                  domainRatingDistribution: res.data,
               },
             });
         } finally {
            dispatch({
               type: digitalPRActions.SET_DOMAIN_RATING_DISTRIBUTION_LOADING,
               payload: { 
                  domainRatingDistributionLoading: false,
               },
             });
         }
     }
     fetchDomainRatingDistribution();
   }, [state.websiteSwitch.currentWebsite])
}

export default useLoadDigitalPR